// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"419":"70560f3a9d30adf0","670":"1f88ab3af907c909","719":"727973242bb33abd"}[chunkId] + ".css";
};